import {
    ADD_TERMINAL_TMS_SCHEME_FAILED, ADD_TERMINAL_TMS_SCHEME_LOADING, ADD_TERMINAL_TMS_SCHEME_SUCCESS
} from "../types";

const initialState = {
    loading: false,
    error: null,
    TmsScheme: null,
    status: null,
};

export const AddTerminalTmsCardReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; status: any; error: any }
) => {
    switch (action.type) {
        case ADD_TERMINAL_TMS_SCHEME_LOADING:
            return {
                ...state,
                loading: action.loading,
            };
        case ADD_TERMINAL_TMS_SCHEME_SUCCESS:
            return {
                ...state,
                loading: false,
                TmsScheme: action.payload,
                status: action.status,
                error: null,
            };
        case ADD_TERMINAL_TMS_SCHEME_FAILED:
            return {
                ...state,
                loading: false,
                TmsScheme: null,
                status: null,
                error: action.error,
            };
        default:
            return state;
    }
};
